<script>
import common_data from "@/util/common_data.js";
import { getDateformat } from '@/util/getDate.js';
import TableCommon from "@/components/table.vue";
import CarItem from '@/components/carListItem.vue'

export default {
  components: {
    TableCommon,
    CarItem
  },
  data() {
    return {
      invoice_id: null,
      invoice_info: {},
      order_info: {
        extend_order_goods: [],
        supplier_info: {},
        extend_order_extend: {
          reciver_infos: {
            combine_detail: '',
            address: ''
          }
        },
        extend_user: {
          mobile: '',
          vip_info: {
            member_level_end_time: '',
            member_level_name: ''
          }
        },
        extend_order_pay: {
          pay_state: ''
        }
      },
      getDateformat,
      goods_table_config:[
          {key:'pay_sn',label:'订单号',type:'text',width:'250px' },
          {key:'goods_info',label:'商品信息',type:'slot',width:'250px' },
          {key:'store_info',label:'所属商家',type:'slot' },
          {key:'order_pay_price',label:'订单实付金额',type:'slot' },
          {key:'order_status',label:'订单状态' ,type:'slot'},
          {key:'create_time',label:'创建时间' ,type:'slot'}
        ],
        order_status: {
          0: "已取消",
          10: "待支付",
          20: "待发货",
          30: "待收货",
          40: "已完成",
          50: "尾款支付",
        }
    };
  },
  created() {
    this.invoice_id = this.$route.params.id
    this.getInvoiceDetail()
  },
  computed: {
    invoice_method_hash() {
      let hash = {};
      common_data.invoice_method.forEach(item => {
        hash[item.id] = item.name;
      })
      return hash;
    },
    invoice_type_hash() {
      let hash = {};
      common_data.invoice_type.forEach(item => {
        hash[item.id] = item.name;
      })
      return hash;
    },
    invoice_title_type_hash() {
      let hash = {};
      common_data.invoice_title_type.forEach(item => {
        hash[`${item.id}`] = item.name;
      })
      return hash;
    },
    invoice_status_hash() {
      let hash = {};
      common_data.invoice_status.forEach(item => {
        hash[item.id] = item.name;
      })
      return hash;
    },
  },
  methods: {
    getInvoiceDetail() {
      this.$axios.post(this.$api.order.invoiceInfo, {
        id: this.invoice_id
      }).then(res => {
        if (res.code == 0) {
          this.invoice_info = res.result
          this.getOrderDetail()
        }
      })
    },
    getOrderDetail() {
      this.$axios.post(this.$api.order.info, {
        id: this.invoice_info.order_id
      }).then(res => {
        if (res.code == 0) {
          let is_vip = res.result.info.extend_user.is_chache_vip
          res.result.info.extend_order_goods.forEach(g => {
            g.order_no = this.invoice_info.order_no
            if (!g.package_id) g.item_info.last_raise_price = is_vip ? g.item_info.vip_raise_price : g.item_info.raise_price
          })
          this.order_info = res.result.info
        }
      })
    },
  },
}
</script>
<template>
  <el-main>
    <div class="page_title">发票详情</div>
    <div class="content_area_box">
      <div class="content_title">发票信息</div>
      <div class="content_grid">
        <div class="content_grid_item">系统发票号 ：{{ invoice_info.system_invoice_no }}</div>
        <div class="content_grid_item">税务发票号 ：{{ invoice_info.invoice_no }}</div>
        <div class="content_grid_item">关联订单号 ：{{ invoice_info.order_no }}</div>
        <div class="content_grid_item">开票主体 ：{{ invoice_info.voucher_issuing_entity }}</div>
        <div class="content_grid_item">发票类型 ：{{ invoice_type_hash[invoice_info.invoice_type] }}</div>
        <div class="content_grid_item">开票时间 ：{{ getDateformat(invoice_info.create_time) }}</div>
        <div class="content_grid_item">发票状态 ：{{ invoice_status_hash[invoice_info.status] }}</div>
        <div class="content_grid_item">抬头类型 ：{{ invoice_title_type_hash[invoice_info.title_type] }}</div>
        <div class="content_grid_item">购方名称 ：{{ invoice_info.invoice_title }}</div>
        <div class="content_grid_item">识别号 ：{{ invoice_info.duty_paragraph }}</div>
        <div class="content_grid_item">开票方式 ：{{ invoice_method_hash[invoice_info.invoice_method] }}</div>
        <div class="content_grid_item">开户银行 ：{{ invoice_info.bank }}</div>
        <div class="content_grid_item">开户账号 ：{{ invoice_info.bank_account }}</div>
        <div class="content_grid_item">公司地址 ：{{ invoice_info.company_address }}</div>
        <div class="content_grid_item">公司电话 ：{{ invoice_info.company_phone }}</div>
      </div>
    </div>
    <div class="content_area_box">
      <div class="content_title">发票内容</div>
      <div class="content_grid">
        <div class="content_grid_item">不含税金额 ：¥{{ invoice_info.order_price }}</div>
        <div class="content_grid_item">税点 ：{{ Number(invoice_info.rake || 0) * 100 }}%</div>
        <div class="content_grid_item">税费 ：¥{{ invoice_info.tax_price }}</div>
        <div class="content_grid_item">开票金额 ：¥{{ invoice_info.invoice_price }}</div>
        <div class="content_grid_item">备注 ：{{ invoice_info.remark }}</div>
      </div>
    </div>
    <div class="content_area_box">
      <div class="content_title">发票文件</div>
      <div class="content_item">
        <div class="label">发票文件 ：</div>
        <div class="value">
          <el-link v-for="(pdf,index) in invoice_info.electronic_invoice_pdfs" :key="pdf.index" :href="pdf.path"
            target="_blank">{{pdf.name}}</el-link>
        </div>
      </div>
    </div>
    <div class="content_area_box">
      <div class="content_title">接收方式</div>
      <div class="content_grid">
        <div class="content_grid_item">电子邮箱 ：{{ invoice_info.email }}</div>
      </div>
    </div>
    <div class="content_area_box" v-if="order_info.id">
      <div class="content_title">商品信息</div>
      <div style="height:20px"></div>
      <TableCommon :data="[order_info]" :table_config="goods_table_config">
        <template #goods_info="{ row }">
          <div v-for="car in row.extend_order_goods" :key="car.id">
            <CarItem v-if="!car.package_id" :car="car.item_info" height="66px"></CarItem>
            <div v-if="car.package_id">
              <div v-for="p_item in car.package_item_list" :key="p_item.id">
                <CarItem :car="p_item" height="66px">
                </CarItem>
              </div>
            </div>
          </div>
        </template>
        <template #store_info="{ row }">
          <div v-if="!row.package_id">{{ order_info.supplier_info.store_name }}</div>
          <div v-if="row.package_id" class="cell_c_info">
            <div class="cell_row center" v-for="(item,index) in row.package_item_list" :key="index">
              {{ order_info.supplier_info.store_name }}
            </div>
          </div>
        </template>
        <template #order_pay_price="{ row }">
          <div class="desc" v-if="Number(row.revise_amount)">¥{{ row.revise_amount }}</div>
          <div class="desc" v-else>¥{{ (Number(row.real_pay_price) + Number(row.final_payment_amount) + Number(row.tax_price)).toFixed(2) }}</div>
        </template>
        <template #order_status="{ row }">
          {{ order_status[row.state] }}
        </template>
        <template #create_time="{ row }">{{ getDateformat(row.create_time) }}</template>
      </TableCommon>
    </div>
  </el-main>
</template>
<style lang="less" scoped>
.el-main {
  width: 100%;
  background: #fff;
  height: 100%;
}
.el-main {
  width: 100%;
  background: #fff;
  height: 100%;
  .page_title {
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
  }
  .content_area_box {
    width: 100%;
    font-weight: bold;
    margin-top: 25px;
    max-width: 1600px;
    &:not(:first-child) {
      margin-top: 24px;
    }
    .content_title {
      font-size: 16px;
      position: relative;
      padding-left: 10px;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 6px;
        height: 14px;
        background: #409eff;
      }
    }
    .content_grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 10px;
      font-size: 14px;
      font-weight: normal;
      margin-top: 14px;
      padding-left: 14px;
      .content_grid_item {
        white-space: nowrap;
      }
    }
    .content_item {
      display: flex;
      font-weight: normal;
      font-size: 14px;
      padding-left: 14px;
      margin-top: 14px;
      .value {
        font-size: 14px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .el-link {
          &:not(:first-child) {
            margin-top: 4px;
          }
        }
      }
    }
  }
}
.cell_c_info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .cell_row {
    flex: 1;
  }
}
.content_area_box :deep(.cellStyle) {
  height: 1px;
  .center {
    height: 100%;
    flex-direction: column;
  }
  .cell {
    height: 100%;
  }
}
</style>